var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconContainsSulphites(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9927,
    cy: 13,
    r: 12.5,
    stroke: "#E5243F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0056 15.4909C20.2193 15.4835 19.5305 15.9034 19.1694 16.5282L16.3338 14.9051C16.4424 14.6435 16.5053 14.3589 16.5082 14.0595C16.5193 12.908 15.6667 11.9475 14.5416 11.7593L14.5698 8.91534C15.5411 8.75011 16.2851 7.92852 16.2944 6.93079C16.3056 5.80627 15.3813 4.88542 14.2304 4.8751C13.0795 4.8642 12.1376 5.76726 12.1265 6.89178C12.1165 7.89008 12.8434 8.72544 13.8117 8.90903L13.7836 11.7536C12.6544 11.9206 11.7829 12.8649 11.7718 14.0164C11.77 14.1983 11.7918 14.375 11.8311 14.5454L8.81345 15.982C8.4394 15.6051 7.91796 15.3687 7.3378 15.363C6.18629 15.3509 5.24441 16.2534 5.23325 17.3785C5.2221 18.503 6.14636 19.4233 7.29728 19.4342C8.4482 19.4451 9.39008 18.542 9.40124 17.4175C9.40418 17.1284 9.34428 16.853 9.23565 16.6034L12.1147 15.2327C12.5252 15.896 13.2656 16.3435 14.1171 16.3515C14.847 16.3584 15.5017 16.0417 15.9409 15.5391L18.9228 17.2454C18.9104 17.3315 18.9016 17.4181 18.9011 17.5076C18.8899 18.6321 19.8136 19.5524 20.9651 19.5633C22.116 19.5742 23.0579 18.6711 23.069 17.5466C23.0808 16.4221 22.1565 15.5018 21.0056 15.4909Z",
    fill: "#E5243F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContainsSulphites);
export default __webpack_public_path__ + "static/media/icon-contains-sulphites.fa750d63e3173cce2cedd47ab0eebd44.svg";
export { ForwardRef as ReactComponent };